import { FC } from "react";

import { GmailColored } from "@livechat/design-system-icons";
import { Icon, Link, SpacingToken, Text } from "@livechat/design-system-react-components";

import { AccordionItem } from "components/accordion-item/AccordionItem";
import Block from "components/layout/Block";
import { config } from "config/config";
import { HelpCenter } from "constants/help-center";
import { IProviderItemProps } from "interfaces/providerItem";
import { withVar } from "themes/helpers";

import { ForwardingAddressCopy } from "./ForwardingAddressCopy";
import { LiWithMargin, StepsList } from "./styles";
import { onHelpCenterLinkClick } from "./trackProviderEngagement";

export const GoogleProvider: FC<IProviderItemProps> = ({
  opened,
  onHeaderClick,
  inboxAddress,
  handleMailboxCopying,
}) => (
  <AccordionItem
    opened={opened}
    onHeaderClick={onHeaderClick}
    title="Gmail / Google Workspace"
    icon={<Icon size="large" source={GmailColored} />}
    className="provider-accordion-item"
  >
    <StepsList>
      <LiWithMargin>
        Access Gmail&apos;s{" "}
        <Link bold target="_blank" href="https://mail.google.com/mail/u/0/#settings/fwdandpop">
          Forwarding and POP/IMAP settings
        </Link>
        .
      </LiWithMargin>
      <LiWithMargin>
        Select <b>&quot;Add a forwarding address&quot;</b>, enter HelpDesk&apos;s forwarding address, and complete the
        verification process as instructed by Google.
        <ForwardingAddressCopy inboxAddress={inboxAddress} handleMailboxCopying={handleMailboxCopying} />
      </LiWithMargin>
      <LiWithMargin>
        After verification, <b>select &quot;Proceed&quot; and &quot;OK&quot; to finalize</b> adding the forwarding
        address.
      </LiWithMargin>
      <LiWithMargin>
        <Link
          bold
          target="_blank"
          href={`${config.appUrl}/tickets/search?query=forwarding-noreply@google.com&silo=tickets`}
        >
          Go to HelpDesk
        </Link>{" "}
        and activate the verification link sent as a ticket to confirm email forwarding.
      </LiWithMargin>
      <LiWithMargin>
        <b>Revisit Gmail&apos;s forwarding settings</b>, select <b>&quot;Forward a copy of incoming mail to&quot;</b> to
        the added HelpDesk&apos;s forwarding address, and save changes.
      </LiWithMargin>
      <LiWithMargin>
        Optional: <b>Send a test message</b> to your own inbox or wait for the first email from a customer.
      </LiWithMargin>
    </StepsList>
    <Block marginTop={withVar(SpacingToken.Spacing4)}>
      <Text>
        Learn more about{" "}
        <Link
          bold={false}
          target="_blank"
          href={HelpCenter.GMAIL_G_SUITE_EMAIL_FORWARDING}
          onClick={onHelpCenterLinkClick}
        >
          Gmail/Google Workspace email forwarding
        </Link>
        .
      </Text>
    </Block>
  </AccordionItem>
);
